<template>
  <div class="sy-list">
    <div class="list-search syue-clr" ref="listSearch" v-if="$slots.search"
         :style="!showTopBorder ? 'border-top: none;' : 'border-radius: 8px;box-shadow: 0px 0px 8px rgba(57, 121, 201, 0.14);'">
      <!-- 按钮区 -->
      <div
        class="list-search-button-group"
        ref="searchButtonGroup"
      >
        <span
          v-if="isNeedFold"
          class="list-search-form-status"
          @click="handleShowMoreSearchForm"
        >
          {{searchFormDefaultStatus ? pageText.packUp : pageText.spread}}
          <i :class="searchFormDefaultStatus ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
        </span>
        <slot name="btn">
          <Buttons v-if="false" size="mini" class="reset-btn" @click="handleReset">{{pageText.reset}}</Buttons>
          <Buttons type="primary" size="mini" class="search-button" @click="handleSearh">{{pageText.search}}</Buttons>
        </slot>
      </div>
      <!-- 搜索区 -->
      <div
        class="list-search-condition syue-clr"
        ref="searchCondition"
        :style="{marginRight: btnGroupW + 'px'}"
      >
        <slot name="search"></slot>
      </div>
    </div>
    <div class="list-handle" :style="!$slots.search ? 'margin-top: 16px;' : ''">
      <slot name="action"></slot>
    </div>
  </div>

</template>

<script>
  import {throttle, cloneDeep} from 'lodash-es'
  import i18n from './i18n.js'
  import {filterProps} from './index.js'
  import ResizeObserver from 'resize-observer-polyfill'
  const pageText = window.fe.getPageText(i18n)

  // 每一项的宽度 用来计算一行最多放几个
  const itemWidth = 254

  export default {
    name: 'filter',
    props: filterProps,
    data () {
      return {
        slotSearch: null,
        lineMaxLen: null,
        // 展开收起状态
        searchFormDefaultStatus: false,
        // 动态计算右侧 查询按钮和展开收起和重置等功能的宽度
        btnGroupW: 119,
        // 当前搜索项数量 是否达到收起范围
        isNeedFold: false,
        filterItemLen: null,
        queryParams: cloneDeep(this.query),
        pageText,
        childCreateInstanse: null,
        childDestroyInstanse: null
      }
    },
    computed: {
      leftPoistion () {
        return this.isNeedFold || this.filterItemLen >= this.lineMaxLen ? '' : `left: ${24 + 254 * this.filterItemLen + 26}px`
      }
    },
    mounted () {
      this.saveRef('filter-search', this)
      // 如果没定义搜索项
      if (!this.$slots.search || !this.$slots.search.length) {
        this.isNeedFold = false
      } else {
        this.$nextTick(() => {
          // this.btnGroupW = this.$refs.searchButtonGroup.offsetWidth
          // if (this.isNeedReset) this.btnGroupW = this.btnGroupW + 61
          this.caclLineItemLen()
          this.toggleFold()
        })
      }
      // let width = this.$el.getBoundingClientRect().width
      const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          if (entry.contentRect.width !== 0) {
            this.handleUpdate()
          }
        }
      })
      resizeObserver.observe(this.$el)
      document.body.addEventListener('keydown', this.keydown)
      this.childCreateInstanse = this.$on('create', this.handleUpdate)
      this.childDestroyInstanse = this.$on('destroy', this.handleUpdate)
    },
    beforeDestroy () {
      document.body.removeEventListener('keydown', this.keydown)
      this.childCreateInstanse.$off('create')
      this.childDestroyInstanse.$off('destroy')
    },
    methods: {
      // 计算一行可以放几个
      caclLineItemLen () {
        // 获取所有搜索项
        let arr = []
        this.recursionFindItem(this.$slots.search, arr)
        this.filterItemLen = arr.length
        this.slotSearch = arr
        // 获取左侧 搜索区宽度 搜索项最后一个没有右间距，它的宽度需要算
        const containerWidth = this.$refs?.searchCondition?.clientWidth - 1 + 20
        this.lineMaxLen = Math.floor(containerWidth / itemWidth)
      },
      // 递归找子组件
      recursionFindItem (arr = [], newArr) {
        for (let index = 0; index < arr.length; index++) {
          const item = arr[index]
          if (item?.componentInstance?.$options?.name === 'filter-item') {
            newArr.push(item)
          } else if (item?.$options?.name === 'filter-item') {
            newArr.push(item.$vnode)
          } else if (item.componentInstance && item.componentInstance.$children && item.componentInstance.$children.length) {
            this.recursionFindItem(item.componentInstance.$children, newArr)
          }
        }
      },
      // 切换展开收起方法
      toggleFold () {
        if (!this.slotSearch || !this.slotSearch.length) {
          return false
        }
        if (this.slotSearch.length <= this.lineMaxLen) {
          this.slotSearch.forEach(item => {
            item.componentInstance.updateVisible(true)
          })
          this.isNeedFold = false
          return true
        }
        this.isNeedFold = true
        // 当前是展开 需要收起
        if (!this.searchFormDefaultStatus) {
          this.slotSearch.forEach((item, idx) => {
            if (idx < this.lineMaxLen) {
              item.componentInstance.updateVisible(true)
            } else {
              item.componentInstance.updateVisible(false)
            }
          })
        } else {
          // 需要全部展开
          this.slotSearch.forEach(item => {
            item.componentInstance.updateVisible(true)
          })
        }
      },
      // 展开收起点击切换
      handleShowMoreSearchForm () {
        this.searchFormDefaultStatus = !this.searchFormDefaultStatus
        this.handleUpdate()
      },
      handleUpdate: throttle(function () {
        this.caclLineItemLen()
        this.toggleFold()
      }, 100),
      handleSearh () {
        this.$emit('search')
        this.setQueryParams()
      },
      handleReset () {
        this.$emit('reset')
        this.setQueryParams()
      },
      // 获取筛选参数
      getFilterQuery () {
        const params = this.queryParams
        params.conditionList = Object.values(params.conditionList).filter(v => {
            if (Array.isArray(v?.value)) {
              return v?.value.some(v => v)
            }
            return v?.value
          })
        delete params.page
        delete params.pageSize
        delete params.pageSizes
        delete params.tab
        delete params.total
        return params
      },
      // 设置筛选参数
      setFilterQuery () {
        this.setQueryParams()
      },
      setQueryParams () {
        this.queryParams = cloneDeep(this.query)
      },
      // 回车事件
      keydown (event) {
        if(event.keyCode === 13){
          //执行的方法
          this.setQueryParams()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .list-search {
    position: relative;
    background: #fff;
    margin-bottom: 8px;
    padding: 16px 24px 8px;
    // overflow: hidden;
    border-radius: 0 0 8px 8px;
    box-shadow: 0px 2px 4px rgba(57, 121, 201, 0.14);
    border: 1px solid #D6DFFF;

    .show {
      overflow: inherit;
    }

    .hide {
      overflow: hidden;
    }
  }

  .list-search-button-group-hide {
    position: absolute;
    top: 40px;

  }

  .list-search-button-group {
    float: right;
    position: relative;
    top: 23px;
  }

  .list-search-button-group, .list-search-button-group-hide {
    .list-search-form-status {
      font-size: 12px;
      cursor: pointer;
      margin-right: 8px;
      color: #242F57;

      &:hover {
        color: #3072F3;
      }

      i {
        transform: scale(0.8);
      }
    }

    .el-button {
      width: 60px;
      height: 32px;
      border-radius: 4px;
    }

    .search-button {
      margin-left: 3px;
    }

    .reset-btn {
      border-color: #dadada;
      background-color: #fff;
      color: #666;
    }
  }

  .list-search-condition {
    font-size: 0px;
  }

  .list-handle {
    margin-bottom: 8px;
    font-size: 0px;
    padding-left: 24px;

    .handle-group {
      > a {
        margin-right: 8px;
        font-size: 12px;

        &:last-child {
          margin-right: 0px;
        }
      }

      > .el-button {
        margin-right: 8px;
        font-size: 12px;

        &:last-child {
          // margin-right: 0px;
        }
      }

      .el-button + .el-button {
        margin-left: 8px;
      }
    }
  }
</style>
